"use client";

import { useMutation } from "@tanstack/react-query";
import { 
  registerUser, 
  loginUser, 
  logoutUser,
  sendOTP,
  verifyOTP,
  loginWithGoogle
} from "../services/userAuth";
import { useRouter } from "next/navigation";
import { auth, googleProvider } from "@/lib/firebase";
import { signInWithPopup } from "firebase/auth";
import toast from "react-hot-toast";

export const useUserRegister = () => {
  return useMutation({
    mutationFn: registerUser,
    onSuccess: (data) => {
      toast.success("Registration Successful")
      return data;
    },
    onError: (error) => {
      toast.error("Registration error:", error.message);
      throw error;
    },
  });
};

export const useSendOTP = () => {
  return useMutation({
    mutationFn: sendOTP,
    onSuccess: () => {
      toast.success("OTP sent successfully")
    },
    onError: (error) => {
      toast.error("OTP send error:", error.message);
      throw error;
    },
  });
};

export const useVerifyOTP = () => {
  const router = useRouter();
  
  return useMutation({
    mutationFn: verifyOTP,
    onSuccess: () => {
      toast.success("OTP verified successfully")
      router.push("/login");
    },
    onError: (error) => {
      toast.error("OTP verification error:", error.message);
      throw error;
    },
  });
};



export const useUserLogin = () => {
  const router = useRouter();

  return useMutation({
    mutationFn: loginUser,
    onSuccess: (data) => {
      // Store token and profile
      localStorage.setItem("userAccessToken", data.token);
      localStorage.setItem("userProfile", JSON.stringify(data.user));

      // Redirect based on user role or default page
      const redirectPath = data.user.role === 'admin' ? '/admin/dashboard' : '/';
      router.push(redirectPath);
      toast.success("Login Successful")
    },
    onError: (error) => {
      console.error("Login error:", error.message);
      toast.error(error.message || "Login failed");
    },
  });
};

export const useUserLogout = () => {
  const router = useRouter();

  return () => {
    logoutUser();
    router.push("/");
  };
};

export const useGoogleLogin = () => {
  const router = useRouter();
  
  return useMutation({
    mutationFn: async () => {
      const result = await signInWithPopup(auth, googleProvider);
      return await result.user.getIdToken();
    },
    onSuccess: async (idToken) => {
      const data = await loginWithGoogle(idToken);
      localStorage.setItem("userAccessToken", data.token);
      localStorage.setItem("userProfile", JSON.stringify(data.user));
      router.push(data.user.role === 'admin' ? '/admin/dashboard' : '/');
      toast.success("Login Successful");
    },
    onError: (error) => {
      toast.error("Google login error:", error);
    }
  });
};